import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { useTranslation } from '../../../hooks/useTranslation'
import { useEffect } from 'react'

export const useJobSearchForm = ({
  urlSearchParams,
  lockParamString,
  noResultQuery,
  setPagesToShow,
  saved_params,
  whatVal,
  companyVal,
  whereVal,
  isIntooItaly,
  isDemo,
}) => {
  const { t } = useTranslation('useJobSearchForm')

  const FormSchema = z
    .object({
      what: z.string().optional(),
      where: z.string().optional(),
      company_name: z.string().optional(),
      sort: z.string().optional(),
      radius: z.union([z.string(), z.number()]).optional(),
      filter_experience_level: z.array(z.string()).optional(),
      filter_job_type: z.array(z.string()).optional(),
      filter_employment_type: z.array(z.string()).optional(),
      filter_date_posted: z.array(z.string()).optional(),
      filter_job_bank_jobs: z.boolean().optional(),
    })
    .refine(
      (data) => {
        // show all job bank jobs for Intoo Italy demo users when selected
        if (isIntooItaly && isDemo && data.filter_job_bank_jobs) return true
        // Otherwise, require at least one of what or where
        return (
          (data.what && data.what.trim() !== '') ||
          (data.where && data.where.trim() !== '')
        )
      },
      {
        message: t('validation.enter_job_title_or_location'),
        path: ['what'], // This will show the error message on the 'what' field
      },
    )

  const form = useForm({
    resolver: zodResolver(FormSchema),
    defaultValues: {
      what: urlSearchParams.get('what') || saved_params.what || '',
      where: urlSearchParams.get('where') || saved_params.where || '',
      company_name:
        urlSearchParams.get('company_name') || saved_params.company_name || '',
      sort: urlSearchParams.get('sort') || saved_params.sort || '',
      radius: urlSearchParams.get('radius') || saved_params.radius,
      filter_experience_level:
        urlSearchParams.getAll('filter_experience_level[]') || [],
      filter_job_type: urlSearchParams.getAll('filter_job_type[]') || [],
      filter_employment_type:
        urlSearchParams.getAll('filter_employment_type[]') || [],
      filter_date_posted: urlSearchParams.getAll('filter_date_posted[]') || [],
      filter_job_bank_jobs:
        urlSearchParams.get('filter_job_bank_jobs') === 'true' || false,
    },
  })

  useEffect(() => {
    if (whatVal) form.setValue('what', whatVal)
  }, [whatVal, form])

  useEffect(() => {
    if (companyVal) form.setValue('company_name', companyVal)
  }, [companyVal, form])

  useEffect(() => {
    if (whereVal) form.setValue('where', whereVal)
  }, [whereVal, form])

  const onSubmit = async (_data) => {
    lockParamString()
    setPagesToShow(1)
  }

  return {
    form,
    onSubmit,
    noResultQuery,
  }
}
